// CooldownContext.js
import { createContext, useContext, useState, useEffect } from "react";

const CooldownContext = createContext();

export const CooldownProvider = ({ children }) => {
  const [cooldown, setCooldown] = useState(0);
  const [cooldownWhats, setCooldownWhats] = useState(0);

  const startCooldown = (type, seconds) => {
    const key = type === "whats" ? "cooldownWhats" : "cooldown";
    const expiresAt = Date.now() + seconds * 1000;
    localStorage.setItem(key, JSON.stringify({ expiresAt }));

    if (type === "whats") setCooldownWhats(seconds);
    else setCooldown(seconds);
  };

  useEffect(() => {
    const storedCooldown = JSON.parse(localStorage.getItem("cooldown"));
    const storedWhats = JSON.parse(localStorage.getItem("cooldownWhats"));

    if (storedCooldown?.expiresAt) {
      const remaining = Math.max(
        0,
        Math.floor((storedCooldown.expiresAt - Date.now()) / 1000)
      );
      setCooldown(remaining);
    }

    if (storedWhats?.expiresAt) {
      const remaining = Math.max(
        0,
        Math.floor((storedWhats.expiresAt - Date.now()) / 1000)
      );
      setCooldownWhats(remaining);
    }
  }, []);

  // ✅ Timer global que decrementa os dois
  useEffect(() => {
    const timer = setInterval(() => {
      setCooldown((prev) => (prev > 0 ? prev - 1 : 0));
      setCooldownWhats((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (cooldown === 0) localStorage.removeItem("cooldown");
  }, [cooldown]);

  useEffect(() => {
    if (cooldownWhats === 0) localStorage.removeItem("cooldownWhats");
  }, [cooldownWhats]);

  return (
    <CooldownContext.Provider
      value={{ cooldown, cooldownWhats, startCooldown }}
    >
      {children}
    </CooldownContext.Provider>
  );
};

export const useCooldown = () => useContext(CooldownContext);
